
    <!--
 * 横版-首充领奖
 * @LastEditTime: Mon Feb 17 2025 18:24:03 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_V3GG18"  :class="[`normal first-charge-page`,`u_c_V3GG18`]" ><div id="u_c_CKWA23"  :class="[`${ compData.title ? 'text' : '' }`,`normal `,`u_c_CKWA23`]" ><div id="u_c_CXUG28"  v-html="compData.title" :class="[`normal`,`u_c_CXUG28`]" ></div></div><div id="u_c_09F017"  v-html="compData.subTitle" :class="[`normal`,`u_c_09F017`]" ></div><div id="u_c_ADSH19"  :class="[`normal award-btn`,`u_c_ADSH19`]" @click="u_c_ADSH19_event_75MQ21($event)">{{`[${ langData.checkGiftBtn }]`}}</div><div id="u_c_EGBY17"  :style="`background-image:url(${ compData.giftIcon })`" :class="[`normal`,`u_c_EGBY17`]" @click="u_c_EGBY17_event_IMSB20($event)"></div><a id="u_c_0LM773" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" :class="[`${ pageData.firstPayState == 2 && pageData.firstPayType != 'sendCoupon' ? 'has' : 'btn-light' }`,`normal   first-charge-award-btn`,`u_c_0LM773`]" @click="u_c_0LM773_event_NP9I65($event)"><div id="u_c_ZVYG26"  :class="[`normal page-common-btn `,`u_c_ZVYG26`]" ><div id="u_c_TMWV33"  v-show="pageData.firstPayState != 2" :class="[`normal `,`u_c_TMWV33`]" >{{`${ langData.getBtn }`}}</div><div id="u_c_NRLX34"  v-show="pageData.firstPayState == 2 && pageData.firstPayType != 'sendCoupon'" :class="[`normal `,`u_c_NRLX34`]" >{{`${ langData.hasBtn }`}}</div><div id="u_c_TWQV36"  v-show="pageData.firstPayState == 2 && pageData.firstPayType == 'sendCoupon'" :class="[`normal `,`u_c_TWQV36`]" >{{`${ langData.useBtn }`}}</div></div></a></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"subTitle":`活动期间，通过官网渠道成功储值任意金额即可领取xxxxxx`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192732109401.png`,"giftName":`首储礼包`,"title":`成神归来
每日赠礼`},"en-US":{"subTitle":`During the event, top up on official website to obtain a reward. The reward can only be claimed once per account.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192732109401.png`,"giftName":`Garnet Jewel*200
Contribution Points Holy Water (Time Limited)*2
Jewel of Life*10`,"title":`1st Top-up Reward`},"ru-RU":{"subTitle":`During the event, top up on official website to obtain a reward. The reward can only be claimed once per account.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192732109401.png`,"giftName":`Joia de Granada*200
Água Benta de Pontos de Contribuição (Tempo Limitado)*2
Joia da Vida*10`,"title":`1st Top-up Reward`},"pt-PT":{"subTitle":`During the event, top up on official website to obtain a reward. The reward can only be claimed once per account.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173943192732109401.png`,"giftName":`Самоцвет Граната*200
Очки взносов Святая вода (Ограниченное время)*2
Самоцвет Жизни*10`,"title":`1st Top-up Reward`}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '首充领奖';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const listData = inject("listData", {})
const showTips = inject("showTips", (txt, code) => {})
const showGetSucc = inject("showGetSucc", (type, pic, name) => {})
const giftInfo = inject("giftInfo", {})
const getCurLink = inject("getCurLink", (link) => {})

giftInfo.firstPayAward = [{
  name: compData.giftName
}]
const curPlatform = pagePlatform;
const canClick = ref(true)

const getFirstGift = async () => {
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'firstPayAward'), {
    params: JSON.stringify({
      language: curLang,
    }),
  })
  if (res.result == 1) {
    pageData.firstPayState = 2
    let curGiftName = pageData.firstPayType == 'sendSerial' ? res.data.send_value : compData.giftName
    showGetSucc(pageData.firstPayType, compData.giftIcon, curGiftName)
  } else {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  }
  return res.result == 1
};
      // 查看奖励的click事件
      const u_c_ADSH19_event_75MQ21= async (e)=>{
        try {pageData.seeGift = [{
  name: compData.giftName,
  pic: compData.giftIcon
}];
pageData.seeGiftPopupState = true;} catch (error) {console.log(error)}
      };
      // 首储道具礼包的click事件
      const u_c_EGBY17_event_IMSB20= async (e)=>{
        try {let arr = []
arr.push({
  name: compData.giftName,
  pic: compData.giftIcon
})
pageData.seeGift = arr;
pageData.seeGiftPopupState = true;} catch (error) {console.log(error)}
      };
      // 领取按钮的click事件
      const u_c_0LM773_event_NP9I65= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
if (+pageData.firstPayState > 1) {
  if (pageData.firstPayType == 'sendCoupon') {
    window.activityDataLayer.push({
      eventName: 'click_button',
      eventType: '前往使用优惠券',
      gameId: pageData.gameId,
      aid: pageData.pageId,
    });
    bridge.open(pageData.storeLink)
  }
  return;
}
if (!canClick.value) return;
canClick.value = false;
window.activityDataLayer.push({
  eventName: 'click_button',
  eventType: '领取首储奖励',
  gameId: pageData.gameId,
  aid: pageData.pageId,
});
await getFirstGift();
canClick.value = true;
} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115963-93.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.default{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16715378206717.png);
margin:auto;
margin-top:2.66vw;
font-size:3.65vw;
color:#fdd76d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.default{
.u_c_CXUG28.normal{
position:relative;

}
}.default{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.default{
.u_c_ADSH19.normal{
position:relative;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.78vw;
cursor:pointer;

}
}.default{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.55vw;
background:no-repeat center;
background-size:contain;
width:20.21vw;
height:15.42vw;
cursor:pointer;

}
}.default{
.u_c_0LM773.normal{
position:relative;
width:21.56vw;
height:7.40vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.default{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.19vw;

}
}.default{
.u_c_TMWV33.normal{
position:relative;

}
}.default{
.u_c_NRLX34.normal{
position:relative;

}
}.default{
.u_c_TWQV36.normal{
position:relative;

}
}.en-US{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115963-93.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.en-US{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.66vw;
font-size:3.65vw;
color:#fdd76d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.en-US{
.u_c_CXUG28.normal{
position:relative;

}
}.en-US{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.en-US{
.u_c_ADSH19.normal{
position:relative;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.78vw;
cursor:pointer;

}
}.en-US{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.55vw;
background:no-repeat center;
background-size:contain;
width:20.21vw;
height:15.42vw;
cursor:pointer;

}
}.en-US{
.u_c_0LM773.normal{
position:relative;
width:21.56vw;
height:7.40vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.en-US{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.19vw;

}
}.en-US{
.u_c_TMWV33.normal{
position:relative;

}
}.en-US{
.u_c_NRLX34.normal{
position:relative;

}
}.en-US{
.u_c_TWQV36.normal{
position:relative;

}
}.ru-RU{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115963-93.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.ru-RU{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.66vw;
font-size:3.65vw;
color:#fdd76d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.ru-RU{
.u_c_CXUG28.normal{
position:relative;

}
}.ru-RU{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.ru-RU{
.u_c_ADSH19.normal{
position:relative;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.78vw;
cursor:pointer;

}
}.ru-RU{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.55vw;
background:no-repeat center;
background-size:contain;
width:20.21vw;
height:15.42vw;
cursor:pointer;

}
}.ru-RU{
.u_c_0LM773.normal{
position:relative;
width:21.56vw;
height:7.40vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.ru-RU{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.19vw;

}
}.ru-RU{
.u_c_TMWV33.normal{
position:relative;

}
}.ru-RU{
.u_c_NRLX34.normal{
position:relative;

}
}.ru-RU{
.u_c_TWQV36.normal{
position:relative;

}
}.pt-PT{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115963-93.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.pt-PT{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.66vw;
font-size:3.65vw;
color:#fdd76d;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.pt-PT{
.u_c_CXUG28.normal{
position:relative;

}
}.pt-PT{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.pt-PT{
.u_c_ADSH19.normal{
position:relative;
font-size:1.15vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.78vw;
cursor:pointer;

}
}.pt-PT{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.55vw;
background:no-repeat center;
background-size:contain;
width:20.21vw;
height:15.42vw;
cursor:pointer;

}
}.pt-PT{
.u_c_0LM773.normal{
position:relative;
width:21.56vw;
height:7.40vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.pt-PT{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.19vw;

}
}.pt-PT{
.u_c_TMWV33.normal{
position:relative;

}
}.pt-PT{
.u_c_NRLX34.normal{
position:relative;

}
}.pt-PT{
.u_c_TWQV36.normal{
position:relative;

}
}
</style>
